import React from "react";
import { useTranslation } from "react-i18next";
import ReactGA from 'react-ga4';
import Subscription from "../../../lib/Subscription";
import { goTo, startFromBikefinder } from "../../../redux/actions/bikefit";
import { useDispatch } from "react-redux";
import bikeTypeSupportsFitting from "../FittingSupport";
import FindBikeButton from "./FindBikeButton";

const SummarySidebar = ({
  mtb,
  title,
  hasGeoFit,
  parts,
  selectGeo,
  selectParts,
  downloadReport,
  traject,
  hasSubscription,
  lastUsedMeasure,
  setMeasureBikefit,
  bikeType,
}) => {
  const [t] = useTranslation("result");
  const dispatch = useDispatch();
  
  const bikefitClicked = () => {
    ReactGA.event({
      action: "click",
      category: "bikefit_summary_sidebar_start",
      label: "Start bikefit from summary sidebar",
      value: 0,
    });
    setMeasureBikefit();
    dispatch(startFromBikefinder(traject, bikeType, true));
    let sittingPosition = "sittingPosition";
    if (traject === "mtb") sittingPosition += "MTB";
    if (traject === "race") sittingPosition += "Road";
    dispatch(goTo("stepB", sittingPosition));
  };

  const subscriptionClicked = () => {
    Subscription.paywall("bikefinder", traject);
  };

  let image = mtb.summary.image;
  if (image.indexOf(",") !== -1) {
    image = mtb.summary.image.split(",")[0];
  }

  return (
    <div className="col-sm-3 filters nopadding">
      <div className="mtbImg">
        <h3>{mtb.bike_model.brand + " " + mtb.bike_model.model}</h3>
        <img
          className="img-responsive"
          src={"/img/bikes/" + image}
          alt={"Afbeelding " + title}
        />
      </div>
      <div className="right-summary">
        <p>
          {t("MTBSummary_Year")}: {mtb.bike_model.year}
          <br />
          {t("MTBSummary_Size")}:{" "}
          {mtb.summary.bike_size === "NA"
            ? t("Result_NotApplicable")
            : mtb.summary.bike_size}
          <br />
          {t("MTBSummary_AdvicePrice")}: &euro;{" "}
          {mtb.summary.price.toLocaleString("nl")}
          <br />
          {t("MTBSummary_Weight")}:{" "}
          {mtb.bike_model.weight
            ? Math.round(mtb.bike_model.weight / 100) / 10 + " kg"
            : t("Result_NotAvailable")}
        </p>

        <div className="details" id="geo">
          <button
            className={
              parts ? "results-section-button" : "active results-section-button"
            }
            onClick={selectGeo}
          >
            {t("MTBSummary_GeoMetricDetails")}
          </button>
        </div>
        <div className="details" id="parts">
          <button
            className={
              parts ? "active results-section-button" : "results-section-button"
            }
            onClick={selectParts}
          >
            {t("MTBSummary_PartsDeails")}
          </button>
        </div>

        <div className="cta-buttons">
          {/*
                                        planTestButton &&
                                        <button className="btn btn-primary"
                                                onClick={this.selectContact}>{t('MTBSummary_FindStore')}</button>
                                    */}
          {/*
                                        !planTestButton &&
                                        <button className="btn btn-primary" data-href={brandUrl}
                                            onClick={this.goToStore}>{t('MTBSummary_FindStore')}</button>
                                    */}

          {/*
                    hasGeoFit &&
                    <button className="btn btn-primary"
                            onClick={downloadReport}>{t('MTBSummary_DownloadReport')}</button>
                    */}

            <FindBikeButton
              className={"btn btn-primary"}
              item={mtb}
              traject={traject}
              source={"summary-sidebar"}
            />

          {lastUsedMeasure !== "bikefit" && bikeTypeSupportsFitting(bikeType) && (
            <button
              className="btn summarySidebarButton"
              onClick={bikefitClicked}
            >
              {t("Start bikefit")}
            </button>
          )}
          {!hasSubscription && (
            <button className="btn btn-primary" onClick={subscriptionClicked}>
              {t("Result_Subscribe")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummarySidebar;
